import { BaseParameterDto } from '../../_models/base-parameter-dto';

export class UserDashboardParametersDto extends BaseParameterDto {
    userId: string;
    includeAll: boolean;

    getQueryString(): string {
        const tokens = [`userId=${this.userId}`, `includeAll=${this.includeAll}`, `clearCache=${this.clearCache}`];
        return tokens.join('&');
    }
}
